export default __webpack_public_path__ + "7ebeed7c7a3e1ccd4215d3fb04c87b2c.svg";